import { Button, EButtonColor } from '@web_opxp/components';
import { FirebaseActions, useTranslation } from '@web_opxp/features';
import { useDispatch, useSelector } from 'react-redux';
import { Action, Dispatch } from 'redux';
import { SKELETON_CLASSNAME } from '../../base/constants';
import { getSubscriptionRestoreStatus } from '../selectors';
import { ManageActions } from '../slice';
import { ESubscriptionRestoreState, TSubscriptionID } from '../types';

export interface IRestoreButtonProps {
  id: TSubscriptionID;
  show: boolean;
}

export default function RestoreButton({ id, show }: Readonly<IRestoreButtonProps>) {
  const { language, t } = useTranslation();
  const restoreStatus = useSelector(getSubscriptionRestoreStatus);
  const loading = restoreStatus === ESubscriptionRestoreState.Running;
  const skeletonClassname = language && !loading ? '' : ` ${SKELETON_CLASSNAME}`;
  const buttonClassname = `restore-button${skeletonClassname}`;
  const dispatch = useDispatch<Dispatch<Action<string>>>();
  const handleRestoreSubscription = () => {
    dispatch(FirebaseActions.analyticsEventAction({ eventName: 'u_restore_button' }));
    dispatch(ManageActions.restoreSubscription(id));
  };
  if (!show) {
    return null;
  }
  return (
    <Button
      color={EButtonColor.green}
      disabled={loading}
      className={buttonClassname}
      label={t('manage:Manage.Subscription.Restore')}
      onClick={handleRestoreSubscription}
    />
  );
}
